import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { IconButton, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, } from '@mui/material';
import { ChevronRight, StarBorderRounded, StarHalfRounded, StarRounded, } from '@mui/icons-material';
export const UiGuideListItem = memo(function UiGuideListItem(props) {
    const { item, status, startLearning } = props;
    const { id, name } = item;
    const icon = useMemo(() => {
        if (!status) {
            return _jsx(StarBorderRounded, {});
        }
        if (status.passed) {
            return _jsx(StarRounded, {});
        }
        return _jsx(StarHalfRounded, {});
    }, [status]);
    const { color, text } = useMemo(() => {
        if (!status) {
            return { color: 'neutral_dark', text: 'Не пройдено' };
        }
        if (status.passed) {
            return { color: 'success', text: 'Пройдено' };
        }
        if (status.skipped) {
            return { color: 'warning', text: 'Пропущено' };
        }
        if (status.rejected) {
            return { color: 'error', text: 'Отменено' };
        }
        return { color: '', text: '' };
    }, [status]);
    return (_jsxs(ListItemButton, { onClick: () => startLearning(id), color: color, divider: true, children: [_jsx(ListItemIcon, { children: icon }), _jsx(ListItemText, { primary: name.substring(0, 1).toUpperCase() + name.substring(1), secondary: text }), _jsx(ListItemSecondaryAction, { children: _jsx(IconButton, { size: "small", edge: "end", children: _jsx(ChevronRight, {}) }) })] }, id));
});
